import { jsx as _jsx } from "react/jsx-runtime";
import { px2remTransformer, StyleProvider } from "@ant-design/cssinjs";
const px2rem = px2remTransformer({
    rootValue: 16,
    mediaQuery: true,
    precision: 5
});
const allowedKeys = new Set(["fontSize"]);
export function pxToRemTransformer(allowedKeys) {
    return {
        visit: (cssObj) => {
            var _a, _b;
            const visited = (_b = (_a = px2rem.visit) === null || _a === void 0 ? void 0 : _a.call(px2rem, cssObj)) !== null && _b !== void 0 ? _b : cssObj;
            const filtered = {};
            for (const key in visited) {
                if (allowedKeys.has(key)) {
                    filtered[key] = visited[key];
                }
                else {
                    filtered[key] = cssObj[key];
                }
            }
            return filtered;
        }
    };
}
export function StyleWrapper(props) {
    return (_jsx(StyleProvider, Object.assign({ hashPriority: "low", transformers: [pxToRemTransformer(allowedKeys)] }, props, { children: props.children })));
}
